// extracted by mini-css-extract-plugin
export default {"modalClose":"ModalCloseExam_modalClose__lo1HP","btnActions":"ModalCloseExam_btnActions__QNUY8","buttonModal":"ModalCloseExam_buttonModal__ySDCN"};